import { render, staticRenderFns } from "./WechatSetting.vue?vue&type=template&id=204e20f2&"
import script from "./WechatSetting.vue?vue&type=script&lang=js&"
export * from "./WechatSetting.vue?vue&type=script&lang=js&"
import style0 from "./WechatSetting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports